export default __webpack_public_path__ + "static/media/cafgu2.18545ea8.svg";